import * as Yup from "yup";

const orcamentoServicoValidator = Yup.object().shape({
  status: Yup.string().nullable(),
  clienteId: Yup.number()
    .transform((value) => (Number.isNaN(value) ? undefined : value))
    .required("Cliente"),
  dataVencimento: Yup.date()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr))
    .required("Data de Vencimento"),
  observacoes: Yup.string().nullable(),
  servicos: Yup.array()
    .transform((value) => (Array.isArray(value) ? value : []))
    .min(1, "Incluir ao menos 1 serviço"),
  pagamentos: Yup.array().min(1, "Incluir ao menos 1 pagamento"),
  ativos: Yup.array()
    .of(
      Yup.object().shape({
        ativoId: Yup.number().required(),
        nome: Yup.string(),
        valoresCampos: Yup.array().test(
          "validar-campos-obrigatorios",
          "Campos obrigatórios não preenchidos",
          function (valoresCampos) {
            const { camposPersonalizados, nome } = this.parent;
            if (!camposPersonalizados || !Array.isArray(camposPersonalizados)) {
              return true;
            }
            const camposFaltantes = [];
            camposPersonalizados.forEach((campoDef) => {
              if (campoDef.obrigatoriedade) {
                const valorEntry = valoresCampos?.find(
                  (v) => v.campoPersonalizadoId === campoDef.id,
                );
                const valor = valorEntry ? valorEntry.valor : "";
                if (valor === "" || valor === null || valor === undefined) {
                  camposFaltantes.push(
                    campoDef.nome || campoDef.label || "Campo sem nome",
                  );
                }
              }
            });
            if (camposFaltantes.length > 0) {
              return this.createError({
                message: `No ativo "${
                  nome || "Item"
                }", preencha: ${camposFaltantes.join(", ")}`,
                path: this.path,
              });
            }
            return true;
          },
        ),
      }),
    )
    .nullable(),
  locaisAvaria: Yup.array().test(
    "validar-tipo-avaria-obrigatoria",
    "Preencher o tipo de avaria dos componentes",
    function () {
      const { locaisAvaria = [], checklistSomenteLeitura } =
        this?.options?.context || {};
      if (checklistSomenteLeitura) return true;
      return !locaisAvaria.some((local) =>
        (local?.componentes || []).some(
          (componente) =>
            componente?.tipoId === null && !!componente?.obrigatoriedade,
        ),
      );
    },
  ),
});

export default orcamentoServicoValidator;
